import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// www olmayan istekleri www'ye yönlendir (SSL sertifikası uyumluluğu için)
if (typeof window !== 'undefined') {
  const hostname = window.location.hostname;
  if (hostname === 'lotussport.net') {
    window.location.replace(`https://www.${hostname}${window.location.pathname}${window.location.search}${window.location.hash}`);
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
